var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07227 7.23438V14.0002H9.92444V7.23438H8.07227Z",
    fill: "grey"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2913 5.70766C8.48841 5.90255 8.72464 6 9 6C9.27536 6 9.51015 5.90255 9.70435 5.70766C9.90145 5.50967 10 5.27301 10 4.99768C10 4.72544 9.90145 4.49188 9.70435 4.29698C9.51015 4.09899 9.27536 4 9 4C8.72464 4 8.48841 4.09899 8.2913 4.29698C8.0971 4.49188 8 4.72544 8 4.99768C8 5.27301 8.0971 5.50967 8.2913 5.70766Z",
    fill: "grey"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0ZM2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9Z",
    fill: "grey"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetInfoIcon);
export default __webpack_public_path__ + "static/media/target-info-icon.5a2f2c7b4d3101c4889e61f42476e2a3.svg";
export { ForwardRef as ReactComponent };